import Vue from 'vue'
import collapsibleBlockSection from './components/shared/blocks/collapsible-block-section.vue';
import previousNextGroup from './components/slideshows-vue/controllers/controller-previous-next-nonoverlay.vue';
import matchIndicators from './components/installation-images-vue/match-indicators.vue';
import overlayWorkDetail from './components/installation-images-vue/overlay-work-detail.vue';


window.addEventListener("DOMContentLoaded", (e) => {
  //collapsible block
  const el = document.querySelector('collapsibleBlockSection');
  let hasIdentifiedWorks = el.getAttribute("hasidentifiedworks");

  new Vue({
    el: el,
    components: { collapsibleBlockSection },
    template: "<collapsibleBlockSection :hasIdentifiedWorks=hasIdentifiedWorks></collapsibleBlockSection>",
    data: {
      hasIdentifiedWorks: hasIdentifiedWorks === "true",
    }
  });

  //previous next buttons
  var previousUrl = document.getElementById("previous-sov");
  if (previousUrl !== null) {
    previousUrl = previousUrl.getAttribute("data-url");
  }

  var nextUrl = document.getElementById("next-sov");
  if (nextUrl !== null) {
    nextUrl = nextUrl.getAttribute("data-url");
  }

  new Vue({
    el: document.querySelector("[data-controls-container]"),
    components: { previousNextGroup },
    template: "<previousNextGroup :previousUrl=previousUrl :nextUrl=nextUrl :gtm=gtm></previousNextGroup>",
    data: {
      previousUrl: previousUrl,
      nextUrl: nextUrl,
      gtm: "installation image",
    }
  });

  //match indicators
  const matchIndicatorElement = document.querySelector("[data-match-indicator-container]");
  var identifiedWorks = [];

  document.querySelectorAll("[data-identified-work]").forEach((elem) => {
    const identifiedWork = {
      "MatchCoordinates": {
        "BL": {
          "X": Number(elem.getAttribute("data-bottom-left-x")),
          "Y": Number(elem.getAttribute("data-bottom-left-y")),
        },
        "BR": {
          "X": Number(elem.getAttribute("data-bottom-right-x")),
          "Y": Number(elem.getAttribute("data-bottom-right-y")),
        }
      },
      "Title": elem.getAttribute("data-object-title"),
      "objectArtist": elem.getAttribute("data-object-artist"),
      "objectDisplayDate": elem.getAttribute("data-object-display-date"),
      "objectId": elem.getAttribute("data-object-id"),
      "objectImageUrl": elem.getAttribute("data-object-image-url"),
      "objectTitle": elem.getAttribute("data-object-title"),
      "objectUrl": elem.getAttribute("data-object-url"),
    };
    identifiedWorks.push(identifiedWork);
  });

  const image = document.querySelector("[data-overlay-image]");
  const imgSrc = image.getAttribute("data-overlay-image-src");
  image.src = imgSrc;

  image.onload = () => {
    new Vue({
      el: matchIndicatorElement,
      components: { matchIndicators },
      template: "<matchIndicators :works=works :height=height :width=width @onClickIdentifiedWork='onClickIdentifiedWork'></matchIndicators>",
      data: {
        works: identifiedWorks,
        height: image.height,
        width: image.width,
      },

      mounted() {
        window.addEventListener('resize', this.onResize);
      },

      destroyed() {
        window.removeEventListener('resize', this.onResize);
      },

      methods: {
        onResize() {
          this.height = Math.round(image.height);
          this.width = Math.round(image.width);
        },

        // overlay work detail
        onClickIdentifiedWork(workIndex) {
          let overlayDetailOpened = true;
          const template = `
            <overlayWorkDetail
              @onClickCloseOverlayWorkDetail="onClickCloseOverlayWorkDetail"
              v-if="overlayDetailOpened"
              ref="overlayDetail"
              :ID=Number(displayedWork.objectId)
              :Title=displayedWork.Title
              :Artist=displayedWork.objectArtist
              :DisplayDate=displayedWork.objectDisplayDate
              :ImageURL=displayedWork.objectImageUrl
              >
            </overlayWorkDetail>
            <div
              v-else
              data-overlay-detail
              >
            </div>
          `
          new Vue({
            el: document.querySelector("[data-overlay-detail]"),
            components: { overlayWorkDetail },
            template: template,
            data: {
              displayedWork: this.works[workIndex],
              overlayDetailOpened: overlayDetailOpened,
            },

            methods: {
              onClickCloseOverlayWorkDetail() {
                this.overlayDetailOpened = false;
              },
            },
          });
        },
      },
    });
  }
});
